import { Avatar, Tree, Spin, Input, Empty, TreeSelect } from 'antd';
import React from 'react';
import { api, app, config } from 'xadmin';
import { C, Loading } from 'xadmin-ui';
import NoData from './NoData'

import _ from 'lodash';

const AvatarIcon = ({ icon, node }) => {
  if (icon) {
    return <Avatar size={20} shape="square" src={config('mediaUrl') + icon} style={{ margin: '0 10px 3px 0' }} />
  } else {
    return <Avatar size={20} shape="square" style={{ margin: '0 10px 3px 0' }}>
      {node ? 'N' : "M"}
    </Avatar>
  }
}
function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  var uuid = s.join("");
  return uuid;
}

const dataFun = (data = [], parentId) => {
  return data.map(item => ({
    ...item,
    title: item.name,
    nodeKey: item.id,
    id: item.id || '',
    modelId: item.model && item.model.id,
    mark_node: (item.model && item.model.id) ? true : false,
    key: item.id + '_' + uuid(),
    parent_id: parentId,
    showicon: true,
    icon: item.icon || (item.model && item.model.icon)
  }))
}


//models 过滤根节点数据
const modelsRootNodeFn = (data = []) => {
  const node = []
  data.map(item => {
    if (item.relations && item.relations.parent && item.relations.parent.length == 0) {
      node.push({
        key: item.id + '_' + uuid(),
        nodeKey: item.id, title: item.name,
        showicon: true,
        ...item
      })
    }
  })
  return node
}

const modelsNodeFn = (data = []) => {
  const node = []
  const _data = _.isArray(data) ? data : [data]
  _data.map(item => {
    node.push({
      key: item.id + '_' + uuid(),
      nodeKey: item.id, title: item.name,
      showicon: true,
      ...item
    })
  })
  return node
}

const renderTreeNodes = (data, multiple, TreeSelects, onlyKey) => {
  let TreeNode = Tree.TreeNode
  if (TreeSelects) TreeNode = TreeSelect.TreeNode
  return data.map((item, i) => {
    const id = onlyKey ? item.key : item.id
    if (item.children) {
      return (
        <TreeNode
          key={item.key}
          dataRef={item}
          title={item.title}
          nodeKey={id}
          value={id}
          disabled={!item.mark_node}
          icon={item.showicon ? <AvatarIcon icon={item.icon} node={item.mark_node} /> : ''}
        >
          {renderTreeNodes(item.children, multiple, TreeSelects, onlyKey)}
        </TreeNode>
      )
    }
    return (<TreeNode
      dataRef={item}
      key={item.key}
      title={item.title}
      nodeKey={id}
      value={id}
      disabled={!item.mark_node}
      icon={item.showicon ? <AvatarIcon icon={item.icon} node={item.mark_node} /> : ''}
    />
    )
  })
}

const formatFilter = (_item, viewSchema) => {
  const item = _.cloneDeep(_item)
  if (!_.isNil(item.value?.gte)) {
    item.value['$gte'] = item.value?.gte
    delete item.value.gte
  }
  if (!_.isNil(item.value?.lte)) {
    item.value['$lte'] = item.value?.lte
    delete item.value.lte
  }
  const field = viewSchema.properties[item.field] || {}
  const format = ['date', 'datetime', 'date-time', 'time']
  if ((field.fieldType == 'datePicker' || format.includes(field.format) || field.type == 'number')
    && typeof item.value !== 'object' && item.method == 'eq') {
    // 时间等于某个值时后台无法查询 处理为大于等于 小于该值+1秒
    if (field.format == 'date' || field.formatType == 'date' || field.type == 'number') {
      return { '$gte': item.value, '$lte': item.value }
    } else {
      return { '$gte': item.value, '$lt': moment(new Date(item.value).getTime() + 1000).format('YYYY-MM-DD HH:mm:ss') }
    }
  }
  if (item.method == 'isNull') {
    return { '$in': [null, {}, []] }
  }
  if (item.method == 'notNull') {
    return { '$nin': [null, {}, []] }
  }
  if (item.method == 'notRange') {
    return { '$not': item.value }
  }
  if (item.method == 'contains') {
    return { '$regex': item.value }
  }
  if (item.method == 'notContains') {
    return { '$not': { '$regex': item.value } }
  }
  if (item.method == 'startsWith') {
    return { '$regex': '^' + item.value }
  }
  if (item.method == 'endsWith') {
    return { '$regex': item.value + '$' }
  }
  if (item.method == 'nin') {
    const val = item.value?.in || item.value
    return { '$nin': _.isArray(val) ? val?.map(v => v?.id || v) : [val.id] }
  }
  if (item.method == 'in') {
    const val = item.value?.in || item.value
    return { '$in': _.isArray(val) ? val?.map(v => v?.id || v) : [val.id] }
  }
  if (item.method == 'eq' && item.value?.like) {
    return { '$regex': item.value?.like }
  }
  if (item.method == 'eq' && item.value?.like) {
    return { '$regex': item.value?.like }
  }
  if (item.method == 'ne' && item.value?.like) {
    return { '$not': { '$regex': item.value?.like } }
  }
  if (item.method == 'ne' || item.method == 'gt' || item.method == 'lt' || item.method == 'gte' || item.method == 'lte') {
    return { [`$${item.method}`]: item?.value?.id || item.value }
  }
  return item.value
}

const convertQueryFilter = (v, viewSchema) => {
  const ws = Object.keys(v)
    .map(item => {
      let k = item
      let rk = item
      const p = _.get(viewSchema.properties, k)
      const type = p && p.type
      if (p && p.key && p.key.indexOf && p.key.indexOf('relate') !== -1) {
        if (v[item]?.id) {
          return { [rk + 'Id']: v[item]?.id }
        } else {
          return { [rk + 'Id']: v[item] }
        }
      } else if (type == 'array') {
        if (v[item]?.id) {
          return { [rk + 'Id']: v[item]?.id }
        } else if (p.fieldType === 'department') {
          return { [rk + 'Id']: v[item] }
        } else {
          return { [rk]: v[item] }
        }
      } else if (type == 'object') {
        return { [rk]: v[item]?.id || v[item] }
      } else {
        return { [rk]: v[item] }
      }
    })
    .reduce((p, c) => ({ ...p, ...c }), {})
  return ws
}

const makeFilter = (condition) => {
  if (condition?.viewSchema) {
    const fs = condition?.cond?.map(c => {
      const values = []
      let filter = {}
      c?.filter(item => item.field).forEach(item => {
        const k = item.field
        values[k] = formatFilter(item, condition?.viewSchema)
      })
      filter = convertQueryFilter(values, condition?.viewSchema)
      if (filter.uid) {
        filter.id = filter.uid
        delete filter.uid
      }
      return filter
    })
    return fs?.length > 1 ? { '$or': fs } : fs?.[0]
  }
}

const useNodeTree = (props, multiple, TreeSelect, project = [], onlyKey) => {
  const [nodes, setNodes] = React.useState([])
  const [datas, setDatas] = React.useState([])
  const [searching, setSearching] = React.useState(false)
  const [searchNodes, setSearchNodes] = React.useState(null)
  const [searchValue, setSearchValue] = React.useState(null)
  const [Loadings, setLoadings] = React.useState(false)

  //异步加载
  const loadData = React.useCallback((treeNode) => {
    const filter = props.nodeFilters ? makeFilter({
      cond: props.nodeFilters,
      viewSchema: _.pick(app.get('models').Node, ['type', 'properties'])
    }) : {}
    return new Promise((resolve) => {
      if (treeNode.props.children) {
        resolve()
        return
      }
      // mark_node为资产标识 true时是models查询
      const { dataRef: { mark_node }, dataRef } = treeNode.props
      const parentId = dataRef.nodeKey
      const Type = mark_node ? 'Model' : 'Node'
      const Where = mark_node ? { 'relations.parentId': dataRef.modelId } : { 'modelId': dataRef.nodeKey, ...(dataRef.parent_id ? { 'parentId': dataRef.parent_id } : {}), ...filter }
      api(app.get('models')[Type])
        .query({ fields: mark_node ? ['icon'] : ['modelId', 'id', 'icon', 'model.icon', 'gis', ...project] }, { where: Where })
        .then(({ items }) => {
          dataRef.children = dataFun(items, parentId)
          setNodes([...nodes])
          setDatas([...dataFun(items, parentId)])
          resolve()
        })
    })
  })

  const onSearch = value => {
    setSearchValue(value)
    onDoSearch(value)
  }
  const onDoSearch = React.useCallback(_.debounce(value => {
    if (value) {
      setSearching(true)
      setSearchNodes([])
      const or = [{ id: { like: value } }, { name: { like: value } }]

      api('Node').query({ limit: 200, fields: ['model.icon', 'id', 'gis', ...project] }, { where: { or } })
        .then(({ items }) => {
          setSearching(false)
          setSearchNodes(dataFun(items))
          setDatas([...dataFun(items)])
        }).catch(err => {
          console.log(err)
          setSearching(false)
          setSearchNodes([])
        })
    } else {
      setSearching(false)
      setSearchNodes(null)
      setSearchValue([])
    }
  }, 500), [])

  React.useEffect(() => {
    if (props.value) {
      setNodes(dataFun([props.value]))
    }
  }, [props.value])

  React.useEffect(() => {
    const { initialValue: node } = props
    setLoadings(true)
    if (node) {
      setSearchValue(node.name || [])
      if (node.model) {
        setSearchNodes(dataFun([node]))
      } else {
        node.id && api('Node').get(node.id).then(node => setSearchNodes(dataFun([node])))
      }
    }
    // 点击输入请求
    if (TreeSelect) return
    ModelQuery()
  }, [JSON.stringify(props.model), JSON.stringify(props.nodeFilters)])

  const ModelQuery = (model) => {
    api(app.get('models').Model)
      .query({ fields: ['relations', 'id', 'icon', 'device', 'warning'] }, { where: props.model?.length ? { 'id': { '$in': props.model.map(item => item.id) } } : {} })
      .then(({ items }) => {
        if (model) {
          setNodes(modelsNodeFn(model))
        } else {
          setNodes(modelsRootNodeFn(items))
        }
        setLoadings(false)
      })
  }

  const children = renderTreeNodes(searchNodes != null ? searchNodes : (nodes || []), multiple, TreeSelect, onlyKey)
  console.log(children)
  const notFoundContent = searching || Loadings ? <div style={{ textAlign: 'center' }}><Spin size="small" /></div> : <NoData />

  return { loadData, onSearch, notFoundContent, children, searchValue, nodes, ModelQuery, datas, Loadings }
}

export default props => {
  const { loadData, onSearch, notFoundContent, children, searchValue, nodes, Loadings } = useNodeTree(props)
  return (<>
    {
      props.showSearch ? <Input.Search
        allowClear
        style={{ marginBottom: 5 }}
        value={searchValue}
        placeholder="输入资产名称或编号"
        onChange={e => onSearch(e.target.value)} />
        : null
    }

    {
      props.showSearch ? Loadings ? <Loading /> : children.length > 0 ? (
        <Tree showLine showIcon onSelect={props.onSelect}
          loadData={loadData} notFoundContent={notFoundContent}
        >
          {children}
        </Tree>
      ) : <NoData />
        : (<Tree showLine showIcon defaultExpandAll onSelect={props.onSelect} loadData={loadData}
          notFoundContent={notFoundContent}
        >
          {children}
        </Tree>)
    }

  </>
  )
}

export { useNodeTree }
